// https://github.com/zeit/next.js/blob/126eb498675e6f1a27d568672c2a9da49eec09f9/examples/with-redux/lib/with-redux-store.js
// From this example https://github.com/zeit/next.js/tree/126eb498675e6f1a27d568672c2a9da49eec09f9/examples/with-redux
import { init } from './configureStore';
const isServer = typeof window === 'undefined';
const __NEXT_REDUX_STORE__ = '__NEXT_REDUX_STORE__';
// The store is a singleton on the client, but is created every time on the server
export function getOrCreateStore(initialState: Partial<ReduxState> = {}) {
  // Always make a new store if server, otherwise state is shared between requests
  if (isServer) {
    return init(initialState);
  }

  // Create store if unavailable on the client and set it on the window object
  if (!window[__NEXT_REDUX_STORE__]) {
    window[__NEXT_REDUX_STORE__] = init(initialState);
  }

  return window[__NEXT_REDUX_STORE__];
}
